import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const downloadCenterAPI = axios.create({
  baseURL: `${API_BASE}/api/download-center`,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Request campaign logs download
 * @param {string} authToken - Authentication token
 * @param {number} campaignId - Campaign ID
 * @returns {Promise} API response
 */
export const requestCampaignLogs = async (authToken, campaignId) => {
  return downloadCenterAPI.post(
    "/request",
    { campaign_id: campaignId },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
};

/**
 * Get all download tasks for user
 * @param {string} authToken - Authentication token
 * @param {Object} filters - Filter options (status, limit, offset)
 * @returns {Promise} API response
 */
export const getDownloadTasks = async (authToken, filters = {}) => {
  return downloadCenterAPI.get("/tasks", {
    params: filters,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

/**
 * Get single download task by ID
 * @param {string} authToken - Authentication token
 * @param {number} taskId - Task ID
 * @returns {Promise} API response
 */
export const getDownloadTaskById = async (authToken, taskId) => {
  return downloadCenterAPI.get(`/tasks/${taskId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

/**
 * Delete download task
 * @param {string} authToken - Authentication token
 * @param {number} taskId - Task ID
 * @returns {Promise} API response
 */
export const deleteDownloadTask = async (authToken, taskId) => {
  return downloadCenterAPI.delete(`/tasks/${taskId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default downloadCenterAPI;

